import React, { useMemo } from 'react';
import { DiscoverFilter } from '@box-types';
import { ImageTile } from '@box/component-library';
import { generateImageSrc } from '@box/utils';

type DiscoverQuickFilterProps = {
  filter: DiscoverFilter;
  onToggle?: (filter: DiscoverFilter) => void;
};

const DiscoverQuickFilter: React.FC<DiscoverQuickFilterProps> = ({ filter, onToggle }) => {
  const imageUrl = useMemo(() => generateImageSrc(filter.webImage), [filter]);
  const altText = filter.title;
  const disabled = filter.shopsCount === 0;

  const handleClick = () => {
    if (!disabled) {
      onToggle?.(filter);
    }
  };

  return (
    <div
      role="link"
      tabIndex={0}
      className="discover-quick-filter-component hover-opacity"
      onClick={handleClick}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
    >
      <ImageTile imgUrl={imageUrl} altText={altText} checked={filter.active} disabled={disabled} />
    </div>
  );
};

export default React.memo(DiscoverQuickFilter);
